export default {
  id: '',
  role: '',
  name: '',
  email: '',
  is_paid: true,
  is_onboarded: false,
  onboarding: {
    course_navigation: true,
    create_roundtable: true,
    create_live_discussion: true,
  },
  preferred_name: '',
  loading: true,
  roundtables: [],
  discussions: [],
  notifications: [],
  my_rt_user_details: {
    id: null,
  },
  avatar_url: null,
  school_info: { school_name: 'School Name', teacher_count: '1' },
  school: { admin_role: '', school_id: '', name: '', synced_school_courses: '' },
  subjects: [],
  grade_levels: [],
  socket_id: null,
  providers: [],
  edlink_integrations: [],
  google_integration: {},
  tester: false,
};



// WEBPACK FOOTER //
// ./src/app/store/modules/account/state.js